import { useDispatch, useSelector } from 'react-redux';
import { fetchLocationDetails } from '../../store/slices/location/locationThunk';
import { useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import { MenuLocationCard } from '../../views/location/location-details/MenuLocationCard';

export function MenuManage() {
  const { user } = useSelector((store) => store.auth);
  const { currentLanguage } = useSelector((store) => store.language);
  const disptach = useDispatch();

  useEffect(() => {
    disptach(fetchLocationDetails(user.locationId));
  }, [disptach, currentLanguage]);
  return (
    <>
      <Row>
        <Col md={12}>
          <MenuLocationCard locationId={user.locationId} />
        </Col>
      </Row>
    </>
  );
}
